module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"location":"Location in Value Chain","selectLocation":"Select location"},"de":{"location":"Standort in Wertschleife","selectLocation":"Standort auswählen"}}')
  delete Component.options._Ctor
}
